import { render, staticRenderFns } from "./ModerationInstructions.vue?vue&type=template&id=263c6fab&lang=pug&"
import script from "./ModerationInstructions.vue?vue&type=script&lang=js&"
export * from "./ModerationInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBanner});
